import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Services {
    constructor(query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;
        this.content = this.el.querySelector('.services__content');
        this.itemsWrap = this.el.querySelector('.services__items');
        this.items = [...this.el.querySelectorAll('.services__item')];

        if (!this.content || !this.itemsWrap || !this.items.length) return;

        this.stackItems = [...this.items];
        this.mm = gsap.matchMedia();

        this.init();
    }

    init() {
        this.mm.add("(min-width: 768px)", () => {
            this.setup({
                contentTop: 80,
                contentGap: 32,
                offsetStep: 16,
                bottomExtra: 40,
                startOffset: 120,
                endOffset: 40,
            });
        });

        this.mm.add("(max-width: 767px)", () => {
            this.setup({
                contentTop: 120,
                contentGap: 24,
                offsetStep: 16,
                bottomExtra: 24,
                startOffset: 80,
                endOffset: 24,
            });
        });
    }

    setup(options) {
        this.contentTop = options.contentTop;
        this.contentGap = options.contentGap;
        this.offsetStep = options.offsetStep;
        this.bottomExtra = options.bottomExtra;
        this.startOffset = options.startOffset;
        this.endOffset = options.endOffset;

        this.maxBgOpacity = 1;
        this.maxBlur = 20;

        this.el.style.setProperty('--content-top', `${this.contentTop}px`);


        const contentHeight = this.content.offsetHeight;
        this.stickyTop = this.contentTop + contentHeight + this.contentGap;

        this.setStackPositions();
        this.setBottomSpace();
        this.initCardBackgrounds();
        this.setContentOffset();
    }

    setStackPositions() {
        this.items.forEach((item, index) => {
            item.style.setProperty('--stack-top', `${this.stickyTop}px`);
            item.style.setProperty('--stack-offset-y', `${index * this.offsetStep}px`);
            item.style.zIndex = index + 1;
        });
    }

    setBottomSpace() {
        const lastIndex = this.items.length - 1;
        const extraSpace = (lastIndex * this.offsetStep) + this.bottomExtra;

        this.itemsWrap.style.setProperty('--stack-bottom-space', `${extraSpace}px`);
    }

    initCardBackgrounds() {
        this.items.forEach((item, index) => {
            if (index === 0) {
                gsap.set(item, {
                    '--card-bg-opacity': this.maxBgOpacity,
                });

                return;
            }

            gsap.fromTo(
                item,
                {
                    '--card-bg-opacity': 0,
                },
                {
                    '--card-bg-opacity': this.maxBgOpacity,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: item,
                        start: `top bottom-=${this.startOffset}`,
                        end: `top ${this.stickyTop + this.endOffset}`,
                        scrub: true,
                    },
                }
            );
        });
    }

    setContentOffset() {
        const firstItemHeight = this.items[0].offsetHeight;

        const stackHeight =
            firstItemHeight +
            ((this.items.length - 1) * this.offsetStep);

        const visualGap = this.contentGap || 32;

        this.content.style.marginBottom =
            `${stackHeight + this.bottomExtra + visualGap}px`;

        this.itemsWrap.style.setProperty(
            '--stack-compensate',
            `${stackHeight}px`
        );
    }
}